module.exports = __webpack_public_path__ + "static/media/logo-dt.61ad109a.svg";